import { defineMessages } from 'react-intl';

export const languageOptionMessages = defineMessages({
  cs: {
    id: 'app.common.czech',
  },
  en: {
    id: 'app.common.english',
  },
  pl: {
    id: 'app.common.polish',
  },
  sk: {
    id: 'app.common.slovak',
  },
});

export const messages = defineMessages({
  languageLabel: {
    id: 'app.inventory.language.label',
  },
});
